import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'

import { IdentificationsAddLoginParamsSchemas } from 'schemas/identificationsSchemas'
import { IdentificationsAddLoginParamsTypes } from 'types/identifications'

export const useMemberIdentificationsAddLoginForm = ({
  defaultValues,
}: {
  defaultValues: IdentificationsAddLoginParamsTypes
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm<IdentificationsAddLoginParamsTypes>({
    resolver: zodResolver(IdentificationsAddLoginParamsSchemas),
    defaultValues,
  })

  return {
    handleSubmit,
    control,
    errors,
    setValue,
    reset,
    watch,
  }
}
